import { render, staticRenderFns } from "./CardScroll.vue?vue&type=template&id=41f53495&scoped=true"
import script from "./CardScroll.vue?vue&type=script&lang=js"
export * from "./CardScroll.vue?vue&type=script&lang=js"
import style0 from "./CardScroll.vue?vue&type=style&index=0&id=41f53495&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f53495",
  null
  
)

export default component.exports